import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { EditSpecialPage } from './edit-special.page';
import { ImageGalleryComponent } from 'src/app/components/image-gallery/image-gallery.component';
import { SpecialDetailComponent } from 'src/app/components/special-detail/special-detail.component';

const routes: Routes = [
  {
    path: '',
    component: EditSpecialPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EditSpecialPage, SpecialDetailComponent, ImageGalleryComponent],
  entryComponents:[
    SpecialDetailComponent,
    ImageGalleryComponent
  ],
  exports:[
    ImageGalleryComponent
  ]
  
})
export class EditSpecialPageModule {}

